import React from 'react';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';

import Loader from '../../../../components/Loader/Loader'

import WhyHostFormBlock2 from '../../../../components/siteadmin/WhyHostPageSettings/WhyHostFormBlock2/WhyHostFormBlock2'
import getWhyHostPageSettings from './getWhyHostPageSettings.graphql';
import { withQuery } from '../../../../hoc/withGraphql';

import s from './WhyHostBlock2.css';

const WhyHostBlock2 = (props) => {

    const { data: { loading, getWhyHostPage }, title } = props;
    if (loading) return <Loader type={"text"} />;

    let settingsCollection = {};
    const dynamicMap = {};

    const BLOCK2_ACTIVE_FIELDS = ['earnBlockTitle1', 'earnBlockContent1'];
    getWhyHostPage?.forEach((item) => {
        settingsCollection[item.name] = item.value;

        if (BLOCK2_ACTIVE_FIELDS.includes(item.name)) {
            item.dynamicWhyHostInfoBlock?.forEach((dynItem) => {
                if (!dynamicMap[dynItem.language]) {
                    dynamicMap[dynItem.language] = { language: dynItem.language };
                }
                dynamicMap[dynItem.language][dynItem.name] = dynItem.value;
            });
        }
    });

    const dynamicValues = Object.values(dynamicMap);

    settingsCollection.dynamicWhyHostInfoBlock = dynamicValues.length > 0
        ? dynamicValues
        : [{
            language: 'en',
            earnBlockTitle1: settingsCollection.earnBlockTitle1,
            earnBlockContent1: settingsCollection.earnBlockContent1,
        }];

    return <WhyHostFormBlock2 initialValues={settingsCollection} title={title} />;
}

WhyHostBlock2.defaultProps = {
    data: {
        loading: false
    }
};

export default compose(
    withStyles(s),
    withQuery(getWhyHostPageSettings, {
        options: {
            fetchPolicy: 'network-only',
            ssr: false
        }
    }),
)(WhyHostBlock2);